import * as React from 'react'
require('../base.module.scss')
import * as st from './Alert.module.scss'
import { Icon, IconType } from '../Icon/Icon'

import { BaseComponentProps } from '../Common/extractClassNamesFromProps'
import { extractClassNamesFromProps } from '../Common/extractClassNamesFromProps'

export const TypeSuccess = Symbol('Success')
export const TypeInfo = Symbol('Info')
export const TypeWarning = Symbol('Warning')
export const TypeError = Symbol('Error')

// FixMe: Using Symbol, until we upgrade to a version of flow that handles string/Symbol literals
// https://flow.org/en/docs/types/literals/
// type alertTypes = Success | Info | Warning | Error
type alertTypes = Symbol

type AlertBaseProps = BaseComponentProps & {
  type: alertTypes
}

const AlertBase: React.ComponentType<AlertBaseProps> = (props) => {
  const type = props.type

  const iconType = type === TypeInfo ? IconType.ALERT_INFO
    : type === TypeSuccess ? IconType.ALERT_SUCCESS
      : type === TypeWarning ? IconType.ALERT_WARNING
        : type === TypeError ? IconType.ALERT_CRITICAL
          : null

  const className = extractClassNamesFromProps(
    props,
    {
      [st.info]: type === TypeInfo,
      [st.success]: type === TypeSuccess,
      [st.warning]: type === TypeWarning,
      [st.error]: type === TypeError
    }
  )
  return (
    <p className={className}>
      {iconType && <Icon use={iconType} className={st.icon} />}
      <span>{props.children}</span>
    </p>
  )
}

export const SuccessAlert: React.ComponentType<any> = (props: BaseComponentProps) => (
  <AlertBase type={TypeSuccess} {...props} />
)

export const InfoAlert: React.ComponentType<any> = (props: BaseComponentProps) => (
  <AlertBase type={TypeInfo} {...props} />
)

export const WarningAlert: React.ComponentType<any> = (props: BaseComponentProps) => (
  <AlertBase type={TypeWarning} {...props} />
)

export const ErrorAlert: React.ComponentType<any> = (props: BaseComponentProps) => (
  <AlertBase type={TypeError} {...props} />
)

// Add displayName to preserve the component name on snapshot testing
SuccessAlert.displayName = 'SuccessAlert'
InfoAlert.displayName = 'InfoAlert'
WarningAlert.displayName = 'WarningAlert'
ErrorAlert.displayName = 'ErrorAlert'
